import { render, staticRenderFns } from "./TipTapModalEditor.vue?vue&type=template&id=23d74ef1"
import script from "./TipTapModalEditor.vue?vue&type=script&lang=js"
export * from "./TipTapModalEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports